import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Members API
export const getMembers = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.politicalGroup) params.append('politicalGroup', filters.politicalGroup);
  if (filters.country) params.append('country', filters.country);
  
  const response = await axios.get(`${API_BASE}/members?${params.toString()}`);
  return response.data;
};

export const getMember = async (id) => {
  const response = await axios.get(`${API_BASE}/members/${id}`);
  return response.data;
};

// Political Groups API
export const getPoliticalGroups = async () => {
  const response = await axios.get(`${API_BASE}/political-groups`);
  return response.data;
};

// Committees API
export const getCommittees = async () => {
  const response = await axios.get(`${API_BASE}/committees`);
  return response.data;
};

export const getCommittee = async (id) => {
  const response = await axios.get(`${API_BASE}/committees/${id}`);
  return response.data;
};

// News API
export const getNews = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.category) params.append('category', filters.category);
  if (filters.limit) params.append('limit', filters.limit);
  
  const response = await axios.get(`${API_BASE}/news?${params.toString()}`);
  return response.data;
};

export const getNewsItem = async (id) => {
  const response = await axios.get(`${API_BASE}/news/${id}`);
  return response.data;
};

// Documents API
export const getDocuments = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.type) params.append('type', filters.type);
  if (filters.status) params.append('status', filters.status);
  
  const response = await axios.get(`${API_BASE}/documents?${params.toString()}`);
  return response.data;
};

export const getDocument = async (id) => {
  const response = await axios.get(`${API_BASE}/documents/${id}`);
  return response.data;
};

// Plenary Sessions API
export const getPlenarySessions = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  
  const response = await axios.get(`${API_BASE}/plenary-sessions?${params.toString()}`);
  return response.data;
};

export const getPlenarySession = async (id) => {
  const response = await axios.get(`${API_BASE}/plenary-sessions/${id}`);
  return response.data;
};

// Stats API
export const getStats = async () => {
  const response = await axios.get(`${API_BASE}/stats`);
  return response.data;
};

// Contact Form API
export const submitContact = async (contactData) => {
  const response = await axios.post(`${API_BASE}/contact`, contactData);
  return response.data;
};

// Subscribe API
export const subscribe = async (subscriptionData) => {
  const response = await axios.post(`${API_BASE}/subscribe`, subscriptionData);
  return response.data;
};

// Get Involved API
export const submitGetInvolved = async (involvementData) => {
  const response = await axios.post(`${API_BASE}/get-involved`, involvementData);
  return response.data;
};
